var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgClock = function SvgClock(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 8.458a8.458 8.458 0 1 1 16.917 0A8.458 8.458 0 0 1 0 8.458Zm9.292-3.416a.833.833 0 0 0-1.667 0v4.097c0 .427.218.825.579 1.054l2.343 1.492a.833.833 0 0 0 .895-1.407L9.292 8.91V5.042Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgClock);
export default ForwardRef;